/** Замена Telegram WebApp API для PWA в браузере. */
export const WebApp = {
  ready: () => {},
  expand: () => {},
  showAlert: (message) => {
    window.alert(String(message || ""));
  },
  showConfirm: (message, callback) => {
    callback(window.confirm(String(message || "")));
  },
  openLink: (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  },
  openTelegramLink: (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  },
  closeScanQrPopup: () => {},
  showScanQrPopup: (_opts, callback) => {
    const raw = window.prompt("Вставьте данные QR-кода (или откройте мобильное приложение для сканирования):");
    if (raw) callback(raw);
  },
  onEvent: () => {},
  offEvent: () => {},
  viewportHeight: typeof window !== "undefined" ? window.innerHeight : 600,
  viewportStableHeight: typeof window !== "undefined" ? window.innerHeight : 600,
  BiometricManager: {
    isInited: false,
    isBiometricAvailable: false,
    init: (cb) => {
      if (cb) cb();
    },
    openSettings: () => {},
    authenticate: (cb) => cb(false),
    updateBiometricToken: (_token, cb) => cb(false),
  },
  LocationManager: {
    isInited: false,
    init(callback) {
      if (!navigator.geolocation) {
        WebApp.showAlert("Геолокация недоступна в этом браузере");
        return;
      }
      this.isInited = true;
      if (callback) callback();
    },
    getLocation(callback) {
      if (!navigator.geolocation) {
        callback(null);
        return;
      }
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          callback({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          });
        },
        () => callback(null),
        { enableHighAccuracy: true, timeout: 15000 }
      );
    },
  },
};
